import axios from "axios/index";
import { dispatchError, API_BASE, config as ApiConfig } from "../api";

export default store => {
  return {
    $store: store,
    getGraphStatistics(locationId) {
      this.$store.commit("loading", true);
      return axios(
        Object.assign(ApiConfig(this.$store), {
          method: "get",
          url: API_BASE + `/locations/${locationId}/graphstatistics/`
        })
      )
        .then(res => {
          this.$store.commit("loading", false);
          return res.data;
        })
        .catch(err => {
          dispatchError(this.$store, err.message);
          throw err;
        });
    },
    getMultiGraphData() {
      this.$store.commit("loading", true);
      return axios(
        Object.assign(ApiConfig(this.$store), {
          method: "get",
          url: "https://run.mocky.io/v3/1ff4a40c-c349-4cc5-9aeb-8265edd44a5a"
        })
      )
        .then(res => {
          this.$store.commit("loading", false);
          return res.data;
        })
        .catch(err => {
          dispatchError(this.$store, err.message);
          throw err;
        });
    },
    purchaseStats(id, data) {
      this.$store.commit("loading", true);
      // http://localhost:8000/api/brands/4/purchasestats/?locations=1&locations=4&date_start=2020-04-01 00:00:00&date_end=2020-05-10 00:00:00
      return axios(
        Object.assign(ApiConfig(this.$store), {
          method: "get",
          url:
            API_BASE + `/brands/${id}/purchasestats/${data ? "?" + data : ""}`
        })
      )
        .then(response => {
          this.$store.commit("loading", false);
          return response.data;
        })
        .catch(error => {
          if (error.response === undefined) {
            dispatchError(
              this.$store,
              "Error de conexión. Inténtelo más tarde"
            );
          } else {
            dispatchError(this.$store, error.response.data.message);
            throw error;
          }
        });
    },
    entryStats(id, data) {
      this.$store.commit("loading", true);
      // http://localhost:8000/api/brands/4/entrystats/?locations=1&locations=4&date_start=2020-04-01 00:00:00&date_end=2020-05-10 00:00:00
      return axios(
        Object.assign(ApiConfig(this.$store), {
          method: "get",
          url: API_BASE + `/brands/${id}/entrystats/${data ? "?" + data : ""}`
        })
      )
        .then(response => {
          this.$store.commit("loading", false);
          return response.data;
        })
        .catch(error => {
          if (error.response === undefined) {
            dispatchError(
              this.$store,
              "Error de conexión. Inténtelo más tarde"
            );
          } else {
            dispatchError(this.$store, error.response.data.message);
            throw error;
          }
        });
    },
    exitStats(id, data) {
      this.$store.commit("loading", true);
      return axios(
        Object.assign(ApiConfig(this.$store), {
          method: "get",
          url: API_BASE + `/brands/${id}/exitstats/${data ? "?" + data : ""}`
        })
      )
        .then(response => {
          this.$store.commit("loading", false);
          return response.data;
        })
        .catch(error => {
          if (error.response === undefined) {
            dispatchError(
              this.$store,
              "Error de conexión. Inténtelo más tarde"
            );
          } else {
            dispatchError(this.$store, error.response.data.message);
            throw error;
          }
        });
    },
    saleStats(id, data) {
      this.$store.commit("loading", true);
      // http://localhost:8000/api/brands/4/salestats/?locations=1&locations=4&date_start=2020-04-01 00:00:00&date_end=2020-05-10 00:00:00
      return axios(
        Object.assign(ApiConfig(this.$store), {
          method: "get",
          url: API_BASE + `/brands/${id}/salestats/${data ? "?" + data : ""}`
        })
      )
        .then(response => {
          this.$store.commit("loading", false);
          return response.data;
        })
        .catch(error => {
          if (error.response === undefined) {
            dispatchError(
              this.$store,
              "Error de conexión. Inténtelo más tarde"
            );
          } else {
            dispatchError(this.$store, error.response.data.message);
            throw error;
          }
        });
    },
    inventoriesStats(id, data) {
      this.$store.commit("loading", true);
      // http://localhost:8000/api/brands/4/salestats/?locations=1&locations=4&date_start=2020-04-01 00:00:00&date_end=2020-05-10 00:00:00
      return axios(
        Object.assign(ApiConfig(this.$store), {
          method: "get",
          url:
            API_BASE + `/brands/${id}/inventorystats/${data ? "?" + data : ""}`
        })
      )
        .then(response => {
          this.$store.commit("loading", false);
          return response.data;
        })
        .catch(error => {
          if (error.response === undefined) {
            dispatchError(
              this.$store,
              "Error de conexión. Inténtelo más tarde"
            );
          } else {
            dispatchError(this.$store, error.response.data.message);
            throw error;
          }
        });
    }
  };
};
